import { notification } from "antd";
import { SignInRequest, SignInResponse, SignUpRequest } from "../../types/auth";
import axiosInstance from "../axiosInstance";

const signIn = async (user: SignInRequest): Promise<SignInResponse> => {
  try {
    const response = await axiosInstance.post<SignInResponse>("/auth", user);
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Usuário ou senha incorretos.",
    });

    throw new Error(`${error}`);
  }
};

const signUp = async (user: SignUpRequest): Promise<SignInResponse> => {
  try {
    const response = await axiosInstance.post<SignInResponse>("/account", user);
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Ocorreu um erro ao criar a conta.",
    });

    throw new Error(`${error}`);
  }
};

const getAccount = async (): Promise<SignUpRequest> => {
  try {
    const response = await axiosInstance.get<SignUpRequest>("/account/current-account");
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Ocorreu um erro ao obter a conta.",
    });

    throw new Error(`${error}`);
  }
};

export const authService = {
  signIn,
  signUp,
  getAccount,
};
